module.exports = __webpack_public_path__ + "images/bf65899ead7efb065be731cfc5beebdbca0bb76efb1321732c17720af2c5fb1f.svg";